import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,
    routes: [{ path: '/close-month', component: FuseLoadable({ loader: () => import('./CloseMonthApp') }) }],
};

export default [Index];
